module.exports = __webpack_public_path__ + "media/fonts/Oricons-073d41e9d21b30fa7ba70c5ac6ea33f1.ttf";